export default {
  name: 'ui/header',
  namespaced: true,
  state: {
    headless: false,
    backAction: null, // 뒤로가기 버튼 커스텀 액션
    progressLength: 0, // 프로그레스바 색칠된 길이
    closeAction: null, // 닫기 버튼 커스텀 액션
  },
  mutations: {
    setBackAction(state, action) {
      state.backAction = action
    },
    setCloseAction(state, action) {
      state.closeAction = action
    },
    setHeadless(state, value) {
      state.headless = value
    },
    /**
     * @param index 현재 단계 번호(0부터 시작)
     * @param length 총 단계 개수
     */
    setProgressLength(state, { index, length }) {
      const tabLength = length
      const tabSize = index + 1
      const percentage = (tabSize / tabLength) * 100
      state.progressLength = percentage - 12 // 마지막 단계에서 약간 모자라보이게
    },
  },
}
